const textContents = {
    "startPage": {
        "Finland": { "type": "Button", "fin": "suomeksi", "rus": "Финский" },
        "Russia": { "type": "Button", "fin": "venäjäksi", "rus": "Русский" },
        "Start": { "type": "Button", "fin": "Aloita peli", "rus": "Начать игру" },
        "GameName": { "type": "Text", "fin": "Tietokilpailu", "rus": "Викторина" },
        "Welcome": { "type": "Text", "fin": "Valitse pelin kieli", "rus": "Выбери язык игры" }
    },
    "topMenu": {
        "NavbarFi": { "type": "Button", "fin": "Su", "rus": "Фи" },
        "NavbarRu": { "type": "Button", "fin": "Ve", "rus": "Ру" },
        "NavbarClose": { "type": "Button", "fin": "X", "rus": "X" },
        "NavbarInfo": { "type": "Button", "fin": "?", "rus": "?" },
        "GameTitle": { "type": "Text", "fin": "Mielenkiintoista tietoa Venäjän kirkoista", "rus": "Интересное о соборах и храмах России" }
    },
    "textGame": {
        "HowToPlay": { "type": "Text", "fin": "Kuinka pelata", "rus": "Как играть" },
        "HowToPlayText": {
            "type": "Text", "fin": ["Vastaa kaikkiin kysymyksiin oikein. Valitse oikea vastaus kahdesta vaihtoehdosta.", " ", "Ole tarkka!", "Laskuri yläpuolella laskee", "oikeiden vastausten määrää.", "Kun vastaat, mene eteenpäin", "nuolen avulla. ", " ", "ONNEA!"],
            "rus": ["Нужно ответить правильно на все вопросы. Для каждого вопроса", "есть два варианта ответов.", " ", "Выбери правильный ответ", "из двух предложенных.", " ", "Будь внимателен! Счётчик в верхней части экрана считает количество правильно отгаданных ответов. После ответа переходи к следующему заданию по стрелочке «Вперёд».", " ", "УДАЧИ!"]
        },
        "Continue": { "type": "Button", "fin": "Jatka", "rus": "Продолжить" },
        "GameOver": { "type": "Text", "fin": "Hyvin tehty!", "rus": "Молодец!" },
        "AllTasksDone": { "type": "Text", "fin": "Kaikki tehtävät on tehty oikein.", "rus": "Все ответы правильные." },
        "SomeTasksDone": { "type": "Text", "fin": "Voit suoriutua paremmin. Kokeile uudestaan!", "rus": "Ты можешь лучше. Попробуй ещё раз!" },
        "PlayAgain": { "type": "Button", "fin": "Aloita alusta", "rus": "Начать с начала" }
    },
    "content": {
        "SpasiteljaMoskva": {
            "fin": {
                "name": "Kristus Vapahtajan katedraali, Moskova",
                "question": ["Minkä sodan voiton kunniaksi rakennettiin", " Kristus Vapahtajan katedraali?"],
                "answer": ["Venäjän-Turkin sota", " 1806-1812"],
                "wrong": "Isänmaallinen sota 1812 "
            },
            "rus": {
                "name": "Храм Христа Спасителя, Mocква",
                "question": ["В честь победы в какой войне решили построить", "Храм Христа Спасителя?"],
                "answer": ["Русско-турецкая война", " 1806-1812"],
                "wrong": "Отечественная война 1812 г."
            }
        },
        "BlagoveschenskyVoronez": {
            "fin": {
                "name": "Neitsyt Marian Ilmestyskirkko, Voronezh",
                "question": ["Katedraalissa ovat Pyhän Mitrofanin Voronezhin pyhäinjäännöksiä.", "Ketä Venäjän tsaaria piispa Mitrofan auttoi?"],
                "answer": "Aleksanteri I",
                "wrong": "Pietari Suuri"
            },
            "rus": {
                "name": "Благовещенский собор, Воронеж",
                "question": ["В соборе находятся мощи святого Митрофана Воронежского.", "Какому русскому царю епископ Митрофан оказывал поддержку?"],
                "answer": "Aлександр I",
                "wrong": "Пётр I"
            }
        },
        "PreobrazenskyChabarovsk": {
            "fin": {
                "name": "Kristuksen kirkastumisen katedraali, Habarovsk",
                "question": ["Kristuksen kirkastumisen katedraali sijaitsee Amurin rannalla.", "Mikä on vastapäisen saaren nimi?"],
                "answer": "Tiikerin saari",
                "wrong": "Ussurin saari"
            },
            "rus": {
                "name": "Спасо-Преображенский собор, Хабаровск",
                "question": ["Спасо-Преображенский собор расположен на берегу Амура.", "Как называется остров, который находится напротив?"],
                "answer": "Тигриный",
                "wrong": "Уссурийский"
            }
        },
        "TroickyMoskva": {
            "fin": {
                "name": "Pyhän kolminaisuuden katedraali, Moskova",
                "question": "Minkä juhlan kunniaksi rakennettiin Pyhän kolminaisuuden katedraali?",
                "answer": "Pääsiäinen",
                "wrong": "Venäjän kasteen 1000 vuotta"
            },
            "rus": {
                "name": "Свято-Троицкий собор, Москвa",
                "question": "В честь какого праздника был возведён собор?",
                "answer": "Праздник Пасхи",
                "wrong": "1000-летие Крещения Руси"
            }
        },
        "UspenskyJaroslavl": {
            "fin": {
                "name": "Uspenskin katedraali, Jaroslavl",
                "question": "Millä vuosisadalla rakennettiin ensimmäinen Uspenski katedraali Jaroslavlissa?",
                "answer": "1400-luvulla",
                "wrong": " 1200-luvulla"
            },
            "rus": {
                "name": "Успенский собор, Ярославль",
                "question": "В каком веке начали строить первый Успенский собор в Ярославле?",
                "answer": "В XV веке",
                "wrong": "В XIII веке"
            }
        },
        "SpasiteljaKaliningrad": {
            "fin": {
                "name": "Kristus Vapahtajan katedraali, Kaliningrad ",
                "question": "Mihin tyyliin Kristus Vapahtajan katedraali on rakennettu?",
                "answer": "Venäläis-Bysanttilainen tyyli",
                "wrong": "Vladimiro-Suzdalin tyyli"
            },
            "rus": {
                "name": "Храм Христа Спасителя, Калининград",
                "question": "В каком стиле простроен Храм Христа Спасителя в Калининграде?",
                "answer": "Русско-Византийском",
                "wrong": "Владимиро-Суздальском"
            }
        },
        "UshakovaSaransk": {
            "fin": {
                "name": "Feodor Ushakovin katedraali, Saransk",
                "question": "Kuka oli Fjodor Ushakov?",
                "answer": "Marsalkka",
                "wrong": "Amiraali"
            },
            "rus": {
                "name": "Собор Феодора Ушакова, Саранск",
                "question": "Кем был Фёдор Ушаков?",
                "answer": "Полководец",
                "wrong": "Адмирал"
            }
        },
        "PreobrazenskyToljaty": {
            "fin": {
                "name": "Kristuksen kirkastumisen katedraali, Toljatti",
                "question": "Katedraalin viereen suunnitellaan 76-metrisen kellotornin rakentamista.  Mitä sinne halutaan sijoittaa?",
                "answer": "Observatorio",
                "wrong": "Maisemapaikka"
            },
            "rus": {
                "name": "Спасо-Преображенский собор, Тольятти",
                "question": ["Рядом с собором планируют построить 76-метровую колокольню.", " Что там хотят разместить?"],
                "answer": "Oбсерваторию",
                "wrong": "Cмотровую площадку"
            }
        },
        "TroickyBrjansk": {
            "fin": {
                "name": "Pyhän kolminaisuuden katedraali, Brjansk",
                "question": "Mikä on 80 metrin korkean kellotornin nimi katedraalin vieressä?",
                "answer": "Jättiläinen",
                "wrong": "Peresvet"
            },
            "rus": {
                "name": "Свято-Троицкий собор, Брянск",
                "question": "Как называется 80-метровая колокольня рядом с собором?",
                "answer": "Великан",
                "wrong": "Пересвет"
            }
        },
        "TroickyPetropavlovsk": {
            "fin": {
                "name": ["Pyhän kolminaisuuden katedraali,", " Petropavlovsk-Kamtšatski"],
                "question": "Montako magnitudia katedraali voi kestää maanjäristyksen aikana?",
                "answer": "8 magnitudia",
                "wrong": "10 magnitudia"
            },
            "rus": {
                "name": ["Свято-Троицкий собор,", " Петропавловск-Камчатский"],
                "question": ["Землетрясение какой магнитуды может выдержать", "Свято-Троицкий собор?"],
                "answer": "8 баллов",
                "wrong": "10 баллов "
            }
        },
        "MihailovskyIzevsk": {
            "fin": {
                "name": "Pyhän Mikaelin katedraali, Iževsk ",
                "question": "Mistä päin Venäjää taiteilijat tulivat maalaamaan katedraalin seinät?",
                "answer": "Gzhelistä",
                "wrong": "Palehista"
            },
            "rus": {
                "name": "Свято-Михайловский собор, Ижевск",
                "question": "Откуда приехали художники расписывать стены собора?",
                "answer": "Гжель",
                "wrong": "Палех"
            }
        },
        "NakroviEkaterenburg": {
            "fin": {
                "name": "Verikirkko, Jekaterinburg",
                "question": "Kenen talo oli tässä paikassa ennen katedraalia?",
                "answer": "Mamontovin talo",
                "wrong": "Ipatjevin talo"
            },
            "rus": {
                "name": " Храм на Крови, Екатеринбург",
                "question": "Чей дом стоял на этом месте до храма?",
                "answer": "Дом Мамонтова",
                "wrong": "Дом Ипатьева"
            }
        },
        "RozdestvaKrasnojarsk": {
            "fin": {
                "name": "Jeesuksen syntymäkirkko, Krasnojarsk",
                "question": "Minkä Siperian joen rannalla kirkko sijaitsee?",
                "answer": "Lenan rannalla",
                "wrong": "Jenisein rannalla"
            },
            "rus": {
                "name": "Храм Рождества Христова, Красноярск",
                "question": "На берегу какой сибирской реки расположен храм?",
                "answer": "Лена",
                "wrong": "Енисей"
            }
        },
        "VladimirskyNovosibirsk": {
            "fin": {
                "name": "Troitse-Vladimirski katedraali, Novosibirsk",
                "question": "Miten korkea katedraali on?",
                "answer": "90 m",
                "wrong": "60 m"
            },
            "rus": {
                "name": "Троице-Владимирский собор, Новосибирск",
                "question": "Какова высота собора?",
                "answer": "90 метров ",
                "wrong": "60 метров"
            }
        },
        "UspenskyChabarovsk": {
            "fin": {
                "name": "Uspenskin katedraali, Habarovsk",
                "question": ["Kuka oli paroni A. N. Korff, joka kuoli vuonna 1893", " ja haudattiin katedraaliin?"],
                "answer": "Habarovskin kaupungin johtaja",
                "wrong": "Amurin alueen kenraalikuvernööri"
            },
            "rus": {
                "name": "Успенский собор, Хабаровск",
                "question": ["Кем был барон А. Н. Корф, который умер в 1893 г.", " и был похоронен в соборе?"],
                "answer": "Градоначальник Хабаровска",
                "wrong": "Генерал-губернатор Приамурья"
            }
        },
        "TroickyTambov": {
            "fin": {
                "name": "Pyhän kolminaisuuden kirkko, Tambov",
                "question": "Mikä on temppelin tärkein ylpeys ja pyhäkkö?",
                "answer": "Tuomiopäivän ikoni",
                "wrong": "Pyhän Nikolauksen ikoni"
            },
            "rus": {
                "name": "Свято-Троицкий храм в Тамбове",
                "question": "Что является главной гордость и святыней храма?",
                "answer": "Икона «Страшный суд»",
                "wrong": "Икона Николая Чудотворца"
            }
        },
        "UspenskyOmsk": {
            "fin": {
                "name": "Uspenskin katedraali, Omsk",
                "question": "Kuka oli katedraalin arkkitehti?",
                "answer": "Joseph Bové",
                "wrong": "Aristoteles Fioravanti"
            },
            "rus": {
                "name": "Успенский собор в Омске",
                "question": "Кто является архитектором собора?",
                "answer": "Осип Бове",
                "wrong": "Аристотель Фьоравант"
            }
        }
    }
};

export default textContents;
